import { gql, useQuery } from '@apollo/client';
import { ModalType } from '../types/ModalType';
import { activeModalVariable } from '../lib/apollo';

export default () => {
  const { data: modalData } = useQuery(GET_ACTIVE_MODAL, {
    fetchPolicy: 'cache-only',
  });

  return {
    activeModal: modalData.activeModal,
    /**
     * @description Turn on a modal by passing a valid ModalType
     * @param modal of type ModalType or null.
     * @returns void
     */
    setActiveModal: (modal: ModalType | null) => {
      activeModalVariable(modal);
    },
    /**
     *
     * @description turns off any active modals.
     * @returns void
     */
    clearModal: () => activeModalVariable(null),
  };
};

const GET_ACTIVE_MODAL = gql`
  query {
    activeModal @client
  }
`;
